var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4599 2.90754C17.676 3.07534 17.7837 3.34755 17.7407 3.61781L15.5936 17.1178C15.5528 17.3746 15.3819 17.5919 15.142 17.6921C14.9021 17.7923 14.6274 17.7611 14.4161 17.6097L10.5141 14.8136L7.71014 17.5379C7.50678 17.7355 7.20939 17.8015 6.94153 17.7085C6.67368 17.6155 6.48116 17.3795 6.44398 17.0984L5.78159 12.0912L2.18941 10.4569C1.9195 10.3341 1.74728 10.0638 1.75003 9.76723C1.75279 9.4707 1.93 9.20364 2.20216 9.08588L16.7022 2.81168C16.9533 2.70301 17.2437 2.73975 17.4599 2.90754ZM4.34887 9.79139L6.78117 10.898C7.01658 11.0051 7.18019 11.2259 7.21411 11.4823L7.73529 15.4221L9.91854 13.3008C10.1789 13.0479 10.583 13.0177 10.878 13.2291L14.3029 15.6832L16.0449 4.73049L4.34887 9.79139Z",
    fill: "#808085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.656375a6.svg";
export { ForwardRef as ReactComponent };